import {
    ref as firebaseRef,
    set,
    onChildAdded,
    onChildRemoved,
    off,
    remove,
    child,
} from 'firebase/database'

import firebaseStorage from '@/utility/firebaseStorage'

const TYPING_TIMEOUT = 1500

const getStorageKey = (userId) => {
    return `user-${userId}`
}

const getTypingPath = (recipientUserId) => {
    const environment = process.env.NODE_ENV
    return `globalTypingStatus/${environment}/${getStorageKey(recipientUserId)}`
}

const state = () => ({
    enabled: false,
    typingUserIds: [],
    typingTimers: {},
})

const mutations = {
    setEnabled(state, value) {
        state.enabled = value
    },
    addTypingUserId(state, userId) {
        if (!state.typingUserIds.includes(userId)) {
            state.typingUserIds.push(userId)
        }
    },
    removeTypingUserId(state, userId) {
        state.typingUserIds = state.typingUserIds.filter((id) => id !== userId)
    },
    setTypingTimer(state, { userId, timerId }) {
        state.typingTimers[userId] = timerId
    },
    clearTypingTimer(state, userId) {
        if (state.typingTimers[userId]) {
            clearTimeout(state.typingTimers[userId])
            delete state.typingTimers[userId]
        }
    },
}

const actions = {
    disable({ state, commit }) {
        if (!state.enabled || !firebaseStorage.typingRef) {
            return
        }

        off(firebaseStorage.typingRef)
        firebaseStorage.typingRef = null

        Object.keys(state.typingTimers).forEach((userId) => {
            commit('clearTypingTimer', userId)
        })

        commit('setEnabled', false)
        commit('typingUserIds', [])
    },

    enable({ state, commit, rootState }) {
        if (state.enabled) {
            return
        }

        commit('setEnabled', true)

        const currentUserId = rootState.onboarding.user.id
        const dbRef = firebaseStorage.db

        const typingPathForMe = getTypingPath(currentUserId)

        firebaseStorage.typingRef = firebaseRef(dbRef, typingPathForMe)

        onChildAdded(firebaseStorage.typingRef, (snapshot) => {
            commit('addTypingUserId', snapshot.key)
        })

        onChildRemoved(firebaseStorage.typingRef, (snapshot) => {
            commit('removeTypingUserId', snapshot.key)
        })
    },

    setUserIsTyping({ commit, rootState }, { typingToUserId }) {
        const currentUserId = getStorageKey(rootState.onboarding.user.id)
        const timerKey = currentUserId

        const typingRefForRecipient = firebaseRef(firebaseStorage.db, getTypingPath(typingToUserId))

        const userRef = child(typingRefForRecipient, currentUserId)

        commit('clearTypingTimer', timerKey)

        set(userRef, true)

        const timerId = setTimeout(() => {
            remove(userRef)
            commit('clearTypingTimer', timerKey)
        }, TYPING_TIMEOUT)

        commit('setTypingTimer', { userId: timerKey, timerId })
    },
}

const getters = {
    isUserTyping: (state) => (userId) => {
        const key = getStorageKey(userId)
        return state.typingUserIds.includes(key)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}